export function localToday() {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
}

export function calculateAge(birthDate?: string | null, today = localToday()): number | null {
  if (!birthDate || !/^\d{4}-\d{2}-\d{2}$/.test(birthDate) || birthDate > today) return null;
  const [year, month, day] = birthDate.split('-').map(Number);
  // Local noon avoids UTC shifting a birthday onto the previous calendar day.
  const date = new Date(`${birthDate}T12:00:00`);
  if (year < 1 || date.getFullYear() !== year || date.getMonth() + 1 !== month || date.getDate() !== day) return null;
  return Number(today.slice(0, 4)) - year - (today.slice(5) < birthDate.slice(5) ? 1 : 0);
}

export function ageLabel(age: number): string {
  if (age === 0) return 'меньше года';
  const lastTwo = age % 100, last = age % 10;
  const unit = lastTwo >= 11 && lastTwo <= 14 ? 'лет' : last === 1 ? 'год' : last >= 2 && last <= 4 ? 'года' : 'лет';
  return `${age} ${unit}`;
}
